import React from 'react';
import { FaWhatsapp } from 'react-icons/fa';
import '../styles/WhatsAppFloat.css';

const WhatsAppFloat = () => {
    const handleWhatsAppClick = () => {
        // IC Harmony 2026 Admin Contact (Anwar)
        const phoneNumber = '6285210488871';
        const message = 'Assalamualaikum, saya ingin bertanya tentang IC Harmony 2026 - Festival Hadroh & Nasyid.';
        const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
        window.open(whatsappUrl, '_blank');
    };

    return (
        <div className="whatsapp-float" onClick={handleWhatsAppClick}>
            <FaWhatsapp className="whatsapp-icon" />
        </div>
    );
};

export default WhatsAppFloat;
